import axios from 'axios';
import { GENERATE_SUB_ENTITY_ONBOARDING_LINK_URL } from '@/utils/constants/constants';

function show_modal(modal_id) {
  const modal_element = document.getElementById(modal_id);
  const bootstrap_modal = window?.bootstrap?.Modal;

  if (!modal_element || !bootstrap_modal) {
    return;
  }

  new bootstrap_modal(modal_element).show();
}

function build_share_payload(vm) {
  const payload = {
    parent_application_id: Number(vm.application_id || 0),
    child_entity_type_id: Number(vm.share_child_entity_type_id || 0),
  };

  return payload;
}

function get_share_payload_error(payload) {
  if (!payload.parent_application_id || !payload.child_entity_type_id) {
    return 'Missing parent application or sub-entity type.';
  }

  return '';
}

function get_share_response_details(response) {
  const response_data = response?.data || {};
  const response_details = {
    is_successful: response_data.status === 'success',
    message: response_data.message || 'Failed to generate onboarding link.',
    share_link: response_data?.data?.share_link || '',
  };

  return response_details;
}

async function copy_text(value) {
  if (!value || !navigator?.clipboard?.writeText) {
    return false;
  }

  await navigator.clipboard.writeText(value);
  return true;
}

export const entity_application_overview_share_methods = {
  reset_share_sub_entity_state() {
    this.share_sub_entity_link = '';
    this.share_sub_entity_error = '';
    this.is_generating_share_link = false;
  },

  async open_share_sub_entity_link_modal(tab_id) {
    this.reset_share_sub_entity_state();
    this.share_child_entity_type_id = this.child_type_id_from_tab(tab_id);
    this.share_child_entity_type_name = this.child_tab_title(tab_id);
    show_modal('share_sub_entity_link_modal');
    await this.generate_share_sub_entity_link();
  },

  async generate_share_sub_entity_link() {
    const payload = build_share_payload(this);
    const payload_error = get_share_payload_error(payload);
    if (payload_error) {
      this.share_sub_entity_error = payload_error;
      return;
    }

    this.is_generating_share_link = true;
    this.share_sub_entity_error = '';
    try {
      const response = await axios.post(
        GENERATE_SUB_ENTITY_ONBOARDING_LINK_URL,
        payload,
        { headers: this.headers }
      );
      const response_details = get_share_response_details(response);
      if (!response_details.is_successful) {
        this.share_sub_entity_error = response_details.message;
        return;
      }

      this.share_sub_entity_link = response_details.share_link;
    } catch (error) {
      this.share_sub_entity_error = error?.response?.data?.message || error.message || 'Failed to generate onboarding link.';
    } finally {
      this.is_generating_share_link = false;
    }
  },

  copy_share_sub_entity_link() {
    copy_text(this.share_sub_entity_link)
      .then((copied) => {
        if (!copied) {
          this.show_error('Clipboard access is unavailable in this browser.');
          return;
        }

        this.show_success('Onboarding link copied to clipboard.');
      })
      .catch((error) => {
        this.show_error(error?.message || 'Failed to copy onboarding link.');
      });
  }
};
